(function () {
  'use strict';

  // Read-only companion to mto-customizer.js. It deliberately shares no state
  // with it: the customiser's selection lives in a closure variable, but the
  // hidden properties[...] inputs it maintains are the values that actually
  // post to the cart. Reading those means the preview and the order line can't
  // drift apart, and it keeps this file safe to delete or restyle on its own.

  // Order matters: it's the display order of the summary rows. 'Fit' has no
  // visual layer — it's a different pattern block, not a surface detail — so it
  // appears in the summary only.
  var CATEGORIES = [
    'Buttons',
    'Undercollar',
    'Belt',
    'Sleeve lining',
    'Piping',
    'Fit',
    'Elbow patches'
  ];

  var root, form, assets, lastFocus = null;

  function init() {
    root = document.querySelector('[data-mto-preview]');
    form = document.getElementById('mto-form');
    if (!root || !form) return;

    var assetTag = document.querySelector('[data-mto-pv-assets]');
    try {
      assets = JSON.parse(assetTag.textContent);
    } catch (e) {
      console.error('Blazer preview: asset map failed to parse', e);
      return;
    }

    warmBase();

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mto-preview-open]')) { open(); return; }
      if (event.target.closest('[data-mto-pv-close]'))     { close(); return; }
      if (event.target.closest('[data-mto-pv-edit]'))      { edit(); return; }
      if (event.target.closest('[data-mto-pv-continue]'))  { continueOn(); }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });
  }

  // The base is by far the largest layer, and every layer starts loading at the
  // same moment the modal opens - so the small option layers arrived first and
  // the modal briefly showed details floating with no blazer behind them.
  //
  // Fetching the base while the browser is idle means it is already cached by
  // the time anyone clicks. Idle rather than a <link rel=preload> so it never
  // competes with the product photography for bandwidth on first paint; a
  // visitor who never opens the preview pays for it only once the page is done.
  function warmBase() {
    if (!assets || !assets.base) return;
    var fetchIt = function () { new Image().src = assets.base; };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fetchIt, { timeout: 3000 });
    } else {
      setTimeout(fetchIt, 1200);
    }
  }

  function prop(name) {
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    return input ? input.value : '';
  }

  // A size is chosen exactly when the page's own add-to-basket button has been
  // enabled — that's the single source of truth mto-customizer.js already
  // maintains, so there's no second copy of the rule to fall out of sync.
  function hasSize() {
    var cta = form.querySelector('.mto-cta');
    return !!cta && !cta.disabled;
  }

  function open() {
    render();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('mto-pv-open');
    var closeBtn = root.querySelector('.mto-pv__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    root.hidden = true;
    document.body.classList.remove('mto-pv-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function render() {
    // Layers
    root.querySelectorAll('[data-mto-layer]').forEach(function (img) {
      var key = img.dataset.mtoLayer;
      var url;

      if (key === 'base') {
        url = assets.base;
      } else {
        var category = {
          buttons: 'Buttons',
          undercollar: 'Undercollar',
          belt: 'Belt',
          sleeve: 'Sleeve lining',
          piping: 'Piping',
          patches: 'Elbow patches'
        }[key];
        var map = assets[category] || {};
        // No entry for the selected value means "nothing to draw" — that's how
        // "Without belt" and "No elbow patches" hide themselves.
        url = map[prop(category)];
      }

      if (url) {
        if (img.getAttribute('src') !== url) img.setAttribute('src', url);
        img.hidden = false;
      } else {
        img.hidden = true;
        img.removeAttribute('src');
      }
    });

    // Summary
    var rows = root.querySelector('[data-mto-pv-rows]');
    rows.textContent = '';
    CATEGORIES.forEach(function (name) {
      var value = prop(name);
      if (!value) return;
      var row = document.createElement('div');
      row.className = 'mto-pv__row';
      var k = document.createElement('span');
      k.className = 'mto-pv__row-key';
      k.textContent = name;
      var v = document.createElement('span');
      v.className = 'mto-pv__row-val';
      v.textContent = value;
      row.appendChild(k);
      row.appendChild(v);
      rows.appendChild(row);
    });

    // Embroidery only earns a row when it's actually been added.
    var embroidery = prop('Embroidery');
    if (embroidery && embroidery !== 'Not requested') {
      var row = document.createElement('div');
      row.className = 'mto-pv__row';
      var k = document.createElement('span');
      k.className = 'mto-pv__row-key';
      k.textContent = 'Embroidery';
      var v = document.createElement('span');
      v.className = 'mto-pv__row-val';
      v.textContent = embroidery;
      row.appendChild(k);
      row.appendChild(v);
      rows.appendChild(row);
    }

    var cta = root.querySelector('[data-mto-pv-continue]');
    cta.textContent = hasSize() ? 'Add to basket' : 'Continue · Choose size';
  }

  function edit() {
    close();
    var customizer = document.querySelector('.mto-customizer');
    if (customizer) customizer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function continueOn() {
    if (!hasSize()) {
      close();
      var trigger  = document.getElementById('mto-size-trigger');
      var dropdown = document.getElementById('mto-size-dropdown');
      if (!trigger) return;
      trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (dropdown && !dropdown.classList.contains('is-open')) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      trigger.focus();
      return;
    }

    // Hand off to the page's real submit button rather than submitting the
    // form here. That keeps product-form-component's handling, the size guard
    // and mto-customizer.js's embroidery add-on listener (which watches for a
    // click on .mto-cta) all working exactly as they do without this modal.
    close();
    var addBtn = form.querySelector('.mto-cta');
    if (addBtn) addBtn.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
